export default __webpack_public_path__ + "static/media/warning.63f3d181.svg";